enum ETemaAplicacao {
  Claro = 'Claro',
  Escuro = 'Escuro',
}

export default ETemaAplicacao;
